import React, {Component} from "react";
import PropTypes from "prop-types";
import {arrayMove} from "react-sortable-hoc";
import SortableCoursesList from './SortableCoursesList';
import SortableSubjectsContainer from './SortableSubjectsContainer';

class SortableSubjects extends Component {
    state = {
        subjects: [...this.props.subjects]
    };

    onSortEnd = ({oldIndex, newIndex}) => {
        let {subjects} = this.state;
        subjects = arrayMove(this.state.subjects, oldIndex, newIndex);
        this.setState({subjects});

    };

    //Lifecycle
    componentWillReceiveProps(nextProps) {
        if (this.state.subjects != nextProps.subjects) {
            this.setState({subjects: nextProps.subjects});
        }
    };

    render() {
        return (
            <SortableSubjectsContainer
                
                onSortEnd={this.props.onSortEnd}
                items={this.state.subjects}
                fullSubjects={this.props.fullSubjects}


            />
        );
    }
}

export default SortableSubjects;


// WEBPACK FOOTER //
// ./src/components/AdminPanel/Strategy/SortableSubjects.js